import { Pipe, PipeTransform } from '@angular/core';
import { ListingModelesText, ListingModelesVideo } from '@components/listing-modeles/models';

@Pipe({ name: 'isListingModelesVideo', standalone: true })
export class IsListingModelesVideoPipe implements PipeTransform {
  transform(value: ListingModelesText | ListingModelesVideo): value is ListingModelesVideo {
    return 'video' in value;
  }
}
